import numeral from 'coact/numeral'

export default function discountParser(text) {
  const num = numeral(text).value()
  if (Number.isNaN(num)) return num
  if (num < 0) return Number.NaN
  if (num <= 1) return num
  return num / 100
}
